/**
 * ⚠️ هذه الصفحة قديمة - تم نقل جميع إعدادات الصور إلى صفحة موحدة
 * 
 * الصفحة الجديدة: /admin/unified-image-settings
 * 
 * يتم إعادة التوجيه تلقائياً...
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  AlertTitle,
  Button,
  Paper,
  Container
} from '@mui/material';
import {
  ArrowForward as ArrowIcon,
  Info as InfoIcon
} from '@mui/icons-material';

const ImageUploadSettingsPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // إعادة توجيه تلقائية بعد 2 ثانية
    const timer = setTimeout(() => {
      navigate('/admin/unified-image-settings', { replace: true });
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="md">
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Alert severity="warning" sx={{ mb: 3 }}>
            <AlertTitle>⚠️ هذه الصفحة قديمة</AlertTitle>
            تم نقل جميع إعدادات الصور إلى صفحة موحدة جديدة
          </Alert>

          <CircularProgress sx={{ mb: 3 }} />

          <Typography variant="h5" gutterBottom>
            جاري إعادة التوجيه...
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            سيتم توجيهك تلقائياً إلى صفحة الإعدادات الموحدة خلال ثانيتين
          </Typography>

          <Button
            variant="contained"
            endIcon={<ArrowIcon />}
            onClick={() => navigate('/admin/unified-image-settings', { replace: true })}
            size="large"
          >
            انتقل الآن إلى الصفحة الموحدة
          </Button>

          <Box sx={{ mt: 3, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
            <Typography variant="caption" color="text.secondary">
              <InfoIcon sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
              الصفحة الجديدة توفر واجهة أفضل وإعدادات موحدة لجميع أنحاء التطبيق
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ImageUploadSettingsPage; 